import React from "react";
import { Paper, Typography } from "@material-ui/core";
import { useTranslation } from "../../langs/useTranslation";
import { BreadCrumbs } from "../../components/device/BreadCrumbs";
import useStyles from "../../styles/groupsStyle";

import { DeviceControlLogsDatatable } from "@/helpers/DeviceControlLogsDatatable";

const DeviceControlLog = () => {
  const { t } = useTranslation("groups");
  const classes = useStyles();

  return (
    <>
      <BreadCrumbs
        noTranslate
        pageName={t({ defaultMessage: "设备命令状态" })}
      />
      <div className={classes.titleWithSelect}>
        <Typography variant="h4">
          {t({ defaultMessage: "设备命令状态" })}
        </Typography>
      </div>
      <Paper elevation={0}>
        <DeviceControlLogsDatatable />
      </Paper>
    </>
  );
};

export default DeviceControlLog;
